import { Box, Grid } from '@mui/material';
import React from 'react';
import '../../../styles/cssStyles.css';
import formatNumberToCurrency from '../../../utils/NumberUtil';
import { Typography } from '@uhc-tempo/components';
import {
    getAppliedToDeductible,
    getCoinsurance,
    getCoPay,
    getMemberPays,
} from '../../../utils/costBreakdownUtil';

const OONTextBlockJSX = (props) => {
    const { singleEstimateResponse, hasOonCoverage, hasDeductible } = props;

    const costShare = singleEstimateResponse?.costShare;

    return (
        <Grid>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #d7d7d7',
                    paddingRight: '16px',
                    paddingBottom: '6px',
                }}
            >
                <Typography.Paragraph
                    style={{ color: '#333333', fontWeight: 500, paddingRight: 16 }}
                >
                    Estimated allowed amount covered by your plan*
                </Typography.Paragraph>
                <Typography.Paragraph style={{ color: '#333333', fontWeight: 500 }}>
                    {singleEstimateResponse?.costShare
                        ? formatNumberToCurrency(costShare?.rate)
                        : '$ --'}
                </Typography.Paragraph>
            </Box>
            {hasOonCoverage && (
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingRight: '16px',
                            paddingTop: '16px',
                        }}
                    >
                        <Typography.Paragraph
                            style={{ color: '#002677', fontWeight: 500, paddingRight: 16 }}
                        >
                            Your costs may include:
                        </Typography.Paragraph>
                    </Box>
                    {hasDeductible && (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                paddingRight: '16px',
                            }}
                        >
                            <Typography.Paragraph
                                style={{ color: '#333333', fontWeight: 500, paddingRight: 16 }}
                            >
                                Applied to deductible
                            </Typography.Paragraph>
                            <Typography.Paragraph style={{ color: '#333333', fontWeight: 500 }}>
                                {getAppliedToDeductible(singleEstimateResponse)}
                            </Typography.Paragraph>
                        </Box>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingRight: '16px',
                        }}
                    >
                        <Typography.Paragraph
                            style={{ color: '#333333', fontWeight: 500, paddingRight: 16 }}
                        >
                            Copay
                        </Typography.Paragraph>
                        <Typography.Paragraph style={{ color: '#333333', fontWeight: 500 }}>
                            {getCoPay(singleEstimateResponse)}
                        </Typography.Paragraph>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            borderBottom: '1px solid #d7d7d7',
                            paddingRight: '16px',
                            paddingBottom: '16px',
                        }}
                    >
                        <Typography.Paragraph
                            style={{ color: '#333333', fontWeight: 500, paddingRight: 16 }}
                        >
                            Coinsurance
                        </Typography.Paragraph>
                        <Typography.Paragraph style={{ color: '#333333', fontWeight: 500 }}>
                            {getCoinsurance(singleEstimateResponse)}
                        </Typography.Paragraph>
                    </Box>
                </>
            )}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #d7d7d7',
                    paddingRight: '16px',
                    paddingBottom: '6px',
                    paddingTop: '16px',
                }}
            >
                <Typography.Paragraph
                    style={{ color: '#333333', fontWeight: 'bold', paddingRight: 16 }}
                >
                    Estimated out-of-pocket cost
                </Typography.Paragraph>
                <Typography.Paragraph style={{ color: '#333333', fontWeight: 'bold' }}>
                    {getMemberPays(singleEstimateResponse)}
                </Typography.Paragraph>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingRight: '16px',
                    paddingTop: '16px',
                }}
            >
                <Typography.Footnote style={{ color: '#333333' }}>
                    <b>*Allowed amount: </b>The maximum amount your plan will pay for a covered item
                    or service from an out-of-network provider.
                </Typography.Footnote>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingRight: '16px',
                }}
            >
                <Typography.Footnote style={{ color: '#333333' }}>
                    If your provider charges more than the allowed amount, you may have to pay that
                    difference in addition to the estimated out-of-pocket cost noted above.
                </Typography.Footnote>
            </Box>
        </Grid>
    );
};

export default OONTextBlockJSX;
